import dashboardProposalTypes from "./Dashboard.types";

// LIST
export const dashboardProposalStart = (data: any) => ({
  type: dashboardProposalTypes.DASHBOARD_PROPOSAL_START,
  payload: data,
});

export const dashboardProposalSuccess = (data: any) => ({
  type: dashboardProposalTypes.DASHBOARD_PROPOSAL_SUCCESS,
  payload: data,
});

export const dashboardProposalFailure = (error: any) => ({
  type: dashboardProposalTypes.DASHBOARD_PROPOSAL_FAILURE,
  payload: error,
});

export const dashboardProposalChanged = () => ({
  type: dashboardProposalTypes.DASHBOARD_PROPOSAL_CHANGED,
});

export const dashboardProposalReset = () => ({
  type: dashboardProposalTypes.DASHBOARD_PROPOSAL_RESET,
});

// DELETE

export const dashboardProposalDeleteStart = (data: any) => ({
  type: dashboardProposalTypes.DASHBOARD_PROPOSAL_DELETE_START,
  payload: data,
});

export const dashboardProposalDeleteSuccess = (data: any) => ({
  type: dashboardProposalTypes.DASHBOARD_PROPOSAL_DELETE_SUCCESS,
  payload: data,
});

export const dashboardProposalDeleteFailure = (error: any) => ({
  type: dashboardProposalTypes.DASHBOARD_PROPOSAL_DELETE_FAILURE,
  payload: error,
});

export const dashboardProposalDeleteChanged = () => ({
  type: dashboardProposalTypes.DASHBOARD_PROPOSAL_DELETE_CHANGED,
});

export const dashboardProposalDeleteReset = () => ({
  type: dashboardProposalTypes.DASHBOARD_PROPOSAL_DELETE_RESET,
});

// export

export const dashboardProposalExportStart = (data: any) => ({
  type: dashboardProposalTypes.DASHBOARD_PROPOSAL_EXPORT_START,
  payload: data,
});

export const dashboardProposalExportSuccess = (data: any) => ({
  type: dashboardProposalTypes.DASHBOARD_PROPOSAL_EXPORT_SUCCESS,
  payload: data,
});

export const dashboardProposalExportFailure = (error: any) => ({
  type: dashboardProposalTypes.DASHBOARD_PROPOSAL_EXPORT_FAILURE,
  payload: error,
});

export const dashboardProposalExportChanged = () => ({
  type: dashboardProposalTypes.DASHBOARD_PROPOSAL_EXPORT_CHANGED,
});

export const dashboardProposalExportReset = () => ({
  type: dashboardProposalTypes.DASHBOARD_PROPOSAL_EXPORT_RESET,
});
